import { ColumnContainer } from '@shared/index';

import { ItemData } from './summary.styles';
import type { Data } from './summary.types';

interface SummaryItemProps {
  data: Data;
  isTotal?: boolean;
}

export const SummaryItem = ({ data, isTotal }: SummaryItemProps) => {
  const { title, description } = data;
  return (
    <ColumnContainer $gap={5}>
      <ItemData
        $isTotal={isTotal}
        $isPrimary={title.isPrimary}
      >
        {title.text}
      </ItemData>
      <ItemData $isPrimary={description.isPrimary}>{description.text}</ItemData>
    </ColumnContainer>
  );
};
